export default {
	init() {
		let lastScroll = 0;
		const header = document.getElementById("site-header");

		window.addEventListener("scroll", () => {
			const currentScroll = window.scrollY;

			if (currentScroll > lastScroll && currentScroll > 100) {
				// Scrolling down
				header.classList.add("header--hidden");
			} else if (currentScroll < lastScroll) {
				// Scrolling up
				header.classList.remove("header--hidden");
			}

			lastScroll = currentScroll;
		});
	},
	destroy() {},
};
